<div class="charts-container custom-scrollbar">
    <div class="chart-area" *ngFor="let item of chartsItems">
        <div class="chart-title">
            <!--i class="material-icons md-24 icon-menu">{{item.icon}}</i--> {{ item.title | translate}}
        </div>
        <div class="chart-container">
            <div #chartRefs [id]="item.ref" class="chart"></div>
            <div class="chart-labels">
                <div *ngFor="let chart of item.list" class="label-item-chart">
                    <div class="pin-color" [style]="'background-color:' + chart.color"></div>
                    <div>{{chart.label| translate}}</div>
                </div><br>
            </div>
        </div>
        <div class="total-container">{{item.list[0].total| translate}}</div>
    </div>

    <div class="card-area" *ngIf="!loading">
        <div class="card-container" *ngFor="let item of cardItems">

            <div class="card-icon"><i class="material-icons md-34 icon-menu-w">{{item.icon}}</i> </div>
            <div class="card-text">
                <div class="card-title"> {{item.label | translate}}</div>
                <div class="item-number">{{item.value}}</div>
            </div>
        </div>
    </div>
</div>